import { OWNER } from './studio/content';

// Shown only when the browser cannot run WebGL: the city and the studio need it, so instead of a blank screen the
// visitor gets a picture of the studio and every way to reach the owner.
export function showFallback() {
  document.getElementById('loading')?.remove();
  const card = document.createElement('main');
  card.className = 'fallback';
  card.innerHTML = `
    <img src="/os/gallery/studio.webp" alt="Salman's studio: a desk with an ultrawide monitor, a PC and a city window at night" />
    <h1>${OWNER.name}</h1>
    <p>Developer from ${OWNER.city}. This portfolio is a 3D city and studio that needs WebGL, which this browser cannot
    run. Try a recent Chrome, Safari, Edge or Firefox, or get in touch directly:</p>
    <nav>
      <a href="https://wa.me/${OWNER.whatsapp}">WhatsApp ${OWNER.whatsappDisplay}</a>
      <a href="mailto:${OWNER.email}">${OWNER.email}</a>
      <a href="${OWNER.github}">GitHub</a>
      <a href="/about">Read my profile</a>
    </nav>`;
  const style = document.createElement('style');
  style.textContent = `
    .fallback { position: fixed; inset: 0; overflow: auto; display: grid; place-content: center; gap: 1rem; padding: 1.5rem;
      max-width: 40rem; margin: 0 auto; color: #e8e2d4; background: #0d1729; font: 16px/1.55 Inter, system-ui, sans-serif; }
    .fallback img { width: 100%; border-radius: 12px; }
    .fallback h1 { margin: 0; font-size: 1.6rem; }
    .fallback p { margin: 0; color: #b9c3c8; }
    .fallback nav { display: flex; flex-wrap: wrap; gap: .5rem; }
    .fallback a { color: #0d1729; background: #efc56e; padding: .55rem .9rem; border-radius: 8px; text-decoration: none; font-weight: 600; }`;
  document.head.append(style);
  document.body.replaceChildren(card);
}
